import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";

export interface CajaAperturaDetailsQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
}

export async function getAllCajaAperturaDetails(aperturaId: string, query?: CajaAperturaDetailsQuery): Promise<QueryResponse<CajaMovimiento>> {
    await sleep(1000);
    const response = await api.get("cajas/aperturas/" + aperturaId + "/details", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCajaAperturaDetailsQuery(aperturaId: string, query: CajaAperturaDetailsQuery = {}, queryConfig: QueryConfig<QueryResponse<CajaMovimiento>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCajaAperturaDetails(aperturaId, query),
        queryKey: ["cajas", "aperturas", aperturaId, "details", query],
    })
}

export interface GetAllCajaAperturaDetailQueryProps {
    aperturaId: string,
    query?: CajaAperturaDetailsQuery,
    queryConfig?: QueryConfig<QueryResponse<CajaMovimiento>>,
    children: (queryResult: QueryResult<QueryResponse<CajaMovimiento>>) => ReactNode
}

export function GetAllCajaAperturaDetailsQuery({
    aperturaId,
    query,
    queryConfig,
    children
}: GetAllCajaAperturaDetailQueryProps) {
    const queryResult = useGetAllCajaAperturaDetailsQuery(aperturaId, query, queryConfig);
    return children && children(queryResult);
}